// 消息模板来自设备固件、GNSS HTTP接口和OTA传输源码；保留格式参数的顺序和原值。
export const ERROR_MESSAGE_TEMPLATES: Array<[string, string]> = [
  ['status=%v active=%v received=%v total=%v progress=%v update_mode=%v peripheral_stage=%v peripheral_progress=%v peripheral_active=%v peripheral_code=%v request_id=%v expected_offset=%v last_chunk_offset=%v last_reject_reason=%v message=%v', '状态=%v 启用=%v 已接收=%v 总长度=%v 进度=%v 升级模式=%v 外设阶段=%v 外设进度=%v 外设启用=%v 外设错误码=%v 请求编号=%v 预期偏移=%v 最后分块偏移=%v 最后拒绝原因=%v 消息=%v'],
  ['device license expired', '设备授权已过期，请重新注册。'],
  ['expired', '设备授权已过期，请重新注册。'],
  ['device not licensed', '设备尚未注册授权，请先注册。'],
  ['device license not registered', '设备尚未注册授权，请先注册。'],
  ['unregistered', '设备尚未注册授权，请先注册。'],
  ['invalid device license', '设备注册码无效，请核对注册码。'],
  ['device license invalid', '设备注册码无效，请核对注册码。'],
  ['radio feature not licensed', '设备未授权使用电台功能。'],
  ['base feature not licensed', '设备未授权使用基站功能。'],
  ['rover feature not licensed', '设备未授权使用移动站功能。'],
  ['monitor feature not licensed', '设备未授权使用监测站功能。'],
  ['storage feature not licensed', '设备未授权使用数据存储功能。'],
  ['device feature not licensed', '设备未授权使用此功能。'],
  ['trusted UTC time unavailable', '设备当前没有可信 UTC 时间，请先让设备联网或完成时间同步后再注册。'],
  ['registration code must start with %s', '注册码必须以 %s 开头'],
  ['registration code payload is empty', '注册码内容为空'],
  ['registration code payload is not valid base64url', '注册码内容不是有效的 base64url 编码'],
  ['registration code payload is not valid JSON', '注册码内容不是有效的 JSON'],
  ['registration code contains deprecated field %s', '注册码包含已废弃字段 %s'],
  ['registration code missing %s', '注册码缺少字段 %s'],
  ['registration code signature_algorithm must be ECDSA_P256_SHA256', '注册码签名算法必须为 ECDSA_P256_SHA256'],
  ['TCP device service not started', 'TCP 设备服务未启动'],
  ['TCP device service unavailable', 'TCP 设备服务不可用'],
  ['TCP device data store not started', 'TCP 设备数据服务未启动'],
  ['device response timeout for %s', '设备响应超时：%s'],
  ['no permission to access this device', '没有访问此设备的权限'],
  ['no permission to register this device', '没有注册此设备的权限'],
  ['no permission to send command to this device', '没有向此设备发送命令的权限'],
  ['device not found or no history data', '设备不存在或没有历史数据'],
  ['device not found or no position data', '设备不存在或没有位置数据'],
  ['device not found or no heartbeat data', '设备不存在或没有心跳数据'],
  ['device not found or no live GNSS data', '设备不存在或没有实时 GNSS 数据'],
  ['device identity warning, license not written', '设备身份校验异常，未写入注册码'],
  ['device identity warning, command not sent', '设备身份校验异常，未发送命令'],
  ['device identity warning, file command not sent', '设备身份校验异常，未发送文件命令'],
  ['device %s identity validation failed', '设备 %s 身份校验失败'],
  ['device identity pending verification for sn %s', '设备 %s 的身份尚待校验'],
  ['device %s not connected', '设备 %s 未连接'],
  ['device connection not available', '设备连接不可用'],
  ['device sn and cmd are required', '设备 SN 和命令不能为空'],
  ['cmd is required', '命令不能为空'],
  ['command payload is empty', '命令内容为空'],
  ['ota_busy', '设备正在升级，请等待升级结束。'],
  ['invalid JSON body: %s', '请求 JSON 格式无效：%s'],
  ['invalid JSON body:', '请求 JSON 格式无效'],
  ['invalid stream', '文件流类型无效'],
  ['invalid file name', '文件名无效'],
  ['invalid time %q', '时间格式无效：%q'],
  ['start must be before end', '开始时间必须早于结束时间'],
  ['file query parameter is required for a multi-file task', '多文件下载任务必须指定文件名'],
  ['download task file not found', '下载任务中的文件不存在'],
  ['download task content file count mismatch', '下载内容的文件数量不一致'],
  ['download task not found', '下载任务不存在'],
  ['download task is not complete', '下载任务尚未完成'],
  ['device %s already has active download task %s', '设备 %s 已有正在执行的下载任务 %s'],
  ['download task exceeds %d bytes aggregate memory limit', '下载任务超过 %d 字节总内存限制'],
  ['download task exceeds %d bytes memory limit', '下载任务超过 %d 字节内存限制'],
  ['duplicate requested file %q', '请求的文件重复：%q'],
  ['requested file %q is not listed by device', '设备文件列表中没有 %q'],
  ['no files matched download task', '没有符合条件的下载文件'],
  ['duplicate download file %q', '下载文件重复：%q'],
  ['download file %q has invalid size %d', '文件 %q 的大小无效：%d'],
  ['download file %q exceeds %d bytes memory limit', '文件 %q 超过 %d 字节内存限制'],
  ['download files exceed %d bytes aggregate memory limit', '下载文件超过 %d 字节总内存限制'],
  ['register push_v1 subscription: %w', '注册文件推送订阅失败：%w'],
  ['push_v1 ACK did not confirm stream_started=true', '文件推送应答未确认数据流已启动'],
  ['push_v1 ACK transfer_id mismatch: got %d want %d', '文件推送应答的传输编号不一致：实际 %d，预期 %d'],
  ['push_v1 ACK offset mismatch: got %d want 0', '文件推送应答的偏移量不一致：实际 %d，预期 0'],
  ['push_v1 ACK max_chunk_data mismatch: got %d want %d', '文件推送应答的最大分块大小不一致：实际 %d，预期 %d'],
  ['push_v1 ACK snapshot_size is missing or invalid', '文件推送应答缺少有效的文件快照大小'],
  ['push_v1 ACK snapshot_size %d exceeds %d bytes memory limit', '文件推送快照 %d 字节超过 %d 字节内存限制'],
  ['push_v1 duplicate chunk content mismatch at offset %d', '文件推送重复分块内容不一致，偏移量 %d'],
  ['push_v1 overlapping duplicate chunk: offset=%d length=%d', '文件推送重复分块重叠：偏移量 %d，长度 %d'],
  ['push_v1 subscription is nil', '文件推送订阅为空'],
  ['push_v1 invalid snapshot_size %d', '文件推送快照大小无效：%d'],
  ['push_v1 idle timeout after %s', '文件推送等待数据超时：%s'],
  ['push_v1 subscription closed: %w', '文件推送订阅已关闭：%w'],
  ['push_v1 subscription closed before EOF', '文件尚未传输结束，推送订阅已关闭'],
  ['push_v1 received nil chunk', '文件推送收到空分块'],
  ['push_v1 transfer_id mismatch: got %d want %d', '文件推送传输编号不一致：实际 %d，预期 %d'],
  ['push_v1 unsupported chunk version %d', '文件推送不支持分块版本 %d'],
  ['push_v1 chunk data length mismatch: declared=%d actual=%d', '文件推送分块长度不一致：声明 %d，实际 %d'],
  ['push_v1 chunk has invalid flags 0x%02X', '文件推送分块标志无效：0x%02X'],
  ['push_v1 device error code %d', '文件推送返回设备错误码 %d'],
  ['push_v1 received too many chunks: got %d limit %d', '文件推送分块数量超限：实际 %d，上限 %d'],
  ['push_v1 chunk data exceeds protocol maximum: got %d limit %d', '文件推送分块超过协议限制：实际 %d，上限 %d'],
  ['push_v1 offset gap: got %d want %d; chunk end %d exceeds snapshot_size %d', '文件推送偏移不连续：实际 %d，预期 %d；分块结束位置 %d 超过快照大小 %d'],
  ['push_v1 data exceeds snapshot_size: got end %d limit %d', '文件推送数据超出快照：结束位置 %d，上限 %d'],
  ['push_v1 received empty non-EOF chunk', '文件推送收到空分块且未标记传输结束'],
  ['push_v1 EOF file size mismatch against snapshot: got end %d want %d', '文件推送结束大小与快照不一致：实际 %d，预期 %d'],
  ['push_v1 received too many sparse ranges: got %d limit %d', '文件推送不连续区间数量超限：实际 %d，上限 %d'],
  ['push_v1 EOF CRC32 mismatch: got 0x%08X want 0x%08X', '文件推送结束时 CRC32 校验不一致：实际 0x%08X，预期 0x%08X'],
  ['push_v1 offset gap repair state is invalid', '文件推送缺失区间补传状态无效'],
  ['push_v1 offset gap repair range [%d,%d) is invalid', '文件推送缺失区间 [%d,%d) 无效'],
  ['push_v1 offset gap repair exceeds missing-byte limit: got more than %d bytes', '文件推送缺失区间超过 %d 字节补传限制'],
  ['push_v1 offset gap repair exceeds request limit %d', '文件推送补传请求超过 %d 次限制'],
  ['push_v1 offset gap repair exceeded %s total timeout', '文件推送补传超过 %s 总时限'],
  ['push_v1 offset gap repair at %d: %w', '文件推送在偏移量 %d 补传失败：%w'],
  ['push_v1 offset gap repair at %d requires chunk_v2-compatible response, got %q', '偏移量 %d 的补传需要兼容 chunk_v2 的响应，实际为 %q'],
  ['push_v1 offset gap repair encoding mismatch at %d: got %q want base64', '偏移量 %d 的补传编码不一致：实际 %q，预期 base64'],
  ['push_v1 offset gap repair offset mismatch: got %d want %d', '文件补传偏移量不一致：实际 %d，预期 %d'],
  ['push_v1 offset gap repair decode at %d: %w', '偏移量 %d 的文件补传解码失败：%w'],
  ['push_v1 offset gap repair length mismatch at %d: declared=%d actual=%d', '偏移量 %d 的补传长度不一致：声明 %d，实际 %d'],
  ['push_v1 offset gap repair returned invalid chunk at %d: length=%d requested=%d missing_end=%d', '偏移量 %d 的补传分块无效：长度 %d，请求长度 %d，缺失区间结束位置 %d'],
  ['push_v1 EOF CRC32 mismatch after offset gap repair: got 0x%08X want 0x%08X', '文件补传后 CRC32 校验不一致：实际 0x%08X，预期 0x%08X'],
  ['DATA_READ_FILE returned empty non-eof chunk', '文件读取返回空分块且未标记文件结束'],
  ['unsupported DATA_READ_FILE encoding %q', '文件读取不支持编码 %q'],
  ['cloud log configuration must not enable DEBUG', '云平台日志配置不允许开启 DEBUG'],
  ['cloud log storage configuration must not enable DEBUG', '云平台日志存储不允许开启 DEBUG'],
  ['cloud log preset must not enable DEBUG', '云平台日志预设不允许开启 DEBUG'],
  ['image confirm response timeout', '固件镜像确认响应超时'],
  ['remote upgrade ack response timeout', '远程升级应答超时'],
  ['ota task transfer cancelled', '升级任务传输已取消'],
  ['ota transfer already completed before transfer begin', '升级传输在开始前已完成'],
  ['ota post-push finalization failed', '升级推送后的最终确认失败'],
  ['firmware %s has %d active ota tasks', '固件 %s 仍有 %d 个进行中的升级任务'],
  ['remote upgrade rejected: %s', '设备拒绝远程升级：%s'],
  ['OTA task id is empty', '升级任务编号为空'],
  ['OTA push already in progress for device %s', '设备 %s 已有正在进行的固件推送'],
  ['open firmware %s: %w', '打开固件 %s 失败：%w'],
  ['seek firmware for retry failed: %w', '重试时定位固件文件失败：%w'],
  ['firmware push failed after %d attempts: %w', '固件推送重试 %d 次后失败：%w'],
  ['firmware push failed after %d attempts', '固件推送重试 %d 次后失败'],
  ['transfer begin rejected: %v', '设备拒绝开始固件传输：%v'],
  ['%w; status probe: %v', '%w；状态查询：%v'],
  ['device response timeout for FIRMWARE_TRANSFER_BEGIN after %d attempts: %w', '开始固件传输的设备响应在尝试 %d 次后仍超时：%w'],
  ['device response timeout for FIRMWARE_TRANSFER_BEGIN after %d attempts', '开始固件传输的设备响应在尝试 %d 次后仍超时'],
  ['FIRMWARE_STATUS probe failed: %w (last status: %s)', '固件状态查询失败：%w（最后状态：%s）'],
  ['FIRMWARE_STATUS did not confirm transfer: %w', '固件状态未确认传输：%w'],
  ['FIRMWARE_STATUS did not confirm transfer (last status: %s)', '固件状态未确认传输（最后状态：%s）'],
  ['transfer begin rejected: empty response', '设备拒绝开始固件传输：响应为空'],
  ['transfer begin rejected: inactive ack (%s)', '设备拒绝开始固件传输：应答未激活（%s）'],
  ['transfer begin rejected: unexpected status %q (%s)', '设备拒绝开始固件传输：状态 %q 不符合预期（%s）'],
  ['transfer begin rejected: total_len mismatch active=%d expected=%d (%s)', '设备拒绝开始固件传输：总长度不一致，实际 %d，预期 %d（%s）'],
  ['transfer begin rejected: update_mode mismatch active=%d expected=%d (%s)', '设备拒绝开始固件传输：升级模式不一致，实际 %d，预期 %d（%s）'],
  ['peripheral bootloader readiness failed (%s)', '外设引导程序准备失败（%s）'],
  ['peripheral transfer became inactive before bootloader ready (%s)', '外设引导程序就绪前传输已停止（%s）'],
  ['%s bootloader ready timeout after %s (last send: %v, last status: %s)', '%s 引导程序等待 %s 后仍未就绪（最后发送：%v，最后状态：%s）'],
  ['firmware push checkpoint overflow: confirmed=%d chunk=%d transfer_total=%d', '固件推送检查点超出范围：已确认 %d，分块 %d，传输总长度 %d'],
  ['firmware chunk send failed after confirmed=%d/%d checkpoint=%d attempts=%d: %w', '固件分块发送失败（已确认 %d/%d，检查点 %d，尝试 %d 次）：%w'],
  ['firmware checkpoint failed after confirmed=%d/%d checkpoint=%d attempts=%d: %w', '固件传输检查点确认失败（已确认 %d/%d，检查点 %d，尝试 %d 次）：%w'],
  ['firmware checkpoint failed after confirmed=%d/%d checkpoint=%d: %w', '固件传输检查点确认失败（已确认 %d/%d，检查点 %d）：%w'],
  ['invalid ota chunk offset=%d transfer_total=%d', '升级分块偏移量无效：%d，传输总长度 %d'],
  ['invalid ota chunk length=%d offset=%d transfer_total=%d', '升级分块无效：长度 %d，偏移量 %d，传输总长度 %d'],
  ['firmware read short at offset=%d read=%d want=%d: %w', '固件读取不足：偏移量 %d，已读取 %d，预期 %d：%w'],
  ['device checkpoint pending for %d after %s: %w', '设备检查点 %d 等待 %s 后仍未确认：%w'],
  ['device response timeout for FIRMWARE_STATUS checkpoint %d after %s (last send: %w, last status: %s)', '设备检查点响应超时（FIRMWARE_STATUS，检查点 %d，等待 %s，最后发送：%w，最后状态：%s）'],
  ['device response timeout for FIRMWARE_STATUS checkpoint %d after %s (last status: %s)', '设备检查点响应超时（FIRMWARE_STATUS，检查点 %d，等待 %s，最后状态：%s）'],
  ['received_len did not reach checkpoint on stale active transfer: received=%d checkpoint=%d (%s)', '旧的活动传输未达到检查点：已接收 %d，检查点 %d（%s）'],
  ['received_len did not reach checkpoint: received=%d checkpoint=%d (%s)', '传输未达到检查点：已接收 %d，检查点 %d（%s）'],
  ['transfer checkpoint rejected: empty status', '设备拒绝传输检查点：状态为空'],
  ['transfer checkpoint rejected: result fail (%s)', '设备拒绝传输检查点：返回失败（%s）'],
  ['device OTA failed: %v', '设备升级失败：%v'],
  ['transfer checkpoint rejected: unexpected status %q (%s)', '设备拒绝传输检查点：状态 %q 不符合预期（%s）'],
  ['transfer checkpoint rejected: total_len mismatch active=%d expected=%d (%s)', '设备拒绝传输检查点：总长度不一致，实际 %d，预期 %d（%s）'],
  ['transfer checkpoint rejected: update_mode mismatch active=%d expected=%d (%s)', '设备拒绝传输检查点：升级模式不一致，实际 %d，预期 %d（%s）'],
  ['empty firmware chunk', '固件分块为空'],
  ['firmware chunk ack timeout for offset=%d checkpoint=%d (last transfer: %s; last status: %s)', '固件分块应答超时：偏移量 %d，检查点 %d（最后传输：%s；最后状态：%s）'],
  ['firmware chunk rejected: %s', '设备拒绝固件分块：%s'],
  ['legacy chunk ACK accepted without progress; waiting for checkpoint', '旧协议分块已应答但无进度，正在等待检查点'],
  ['invalid firmware chunk range: offset=%d len=%d total=%d', '固件分块范围无效：偏移量 %d，长度 %d，总长度 %d'],
  ['invalid OTA update mode: %d', '升级模式无效：%d'],
  ['invalid OTA total length: %d', '升级总长度无效：%d'],
  ['invalid OTA offset: %d', '升级偏移量无效：%d'],
  ['OTA chunk too large: %d', '升级分块过大：%d'],
  ['invalid OTA chunk range: offset=%d len=%d total=%d', '升级分块范围无效：偏移量 %d，长度 %d，总长度 %d'],
  ['OTA frame payload too large: frame_len=%d max=%d', '升级帧内容过大：帧长 %d，最大 %d'],
  ['device response timeout for FIRMWARE_STATUS (last send: %w, last status: %s)', '固件状态响应超时（最后发送：%w，最后状态：%s）'],
  ['device response timeout for FIRMWARE_STATUS (last status: %s)', '固件状态响应超时（最后状态：%s）'],
  ['peripheral OTA failed: code=%d message=%s', '外设升级失败：错误码 %d，原因 %s'],
  ['peripheral OTA timeout waiting for DONE (last send: %w)', '等待外设升级完成超时（最后发送：%w）'],
  ['peripheral OTA timeout waiting for DONE', '等待外设升级完成超时'],
  ['device response timeout for CONTROL_HOST reboot ack (ignored: %s)', '设备重启应答超时（已忽略：%s）'],
  ['device response timeout for CONTROL_HOST reboot ack', '设备重启应答超时'],
  ['post-reboot firmware verification timeout', '重启后固件验证超时'],
  ['post-reboot firmware version mismatch from %s: got %s want %s', '重启后固件版本不一致（%s）：实际 %s，预期 %s'],
  ['send image confirm failed: %w', '发送固件镜像确认失败：%w'],
  ['image confirm rejected: %v', '设备拒绝固件镜像确认：%v'],
  ['binary file chunk subscription not found', '二进制文件分块订阅不存在'],
  ['binary file chunk subscription full', '二进制文件分块订阅已满'],
  ['binary file chunk subscription SN is required', '二进制文件分块订阅必须指定设备 SN'],
  ['binary file chunk subscription transfer ID must be non-zero', '二进制文件分块传输编号不能为零'],
  ['binary file chunk subscription already registered for SN=%s transfer_id=%d', '设备 %s 的传输编号 %d 已注册分块订阅'],
  ['binary file chunk is nil', '二进制文件分块为空'],
  ['TCP server listen failed: %w', 'TCP 服务监听失败：%w'],
  ['build frame failed: %w', '构造通信帧失败：%w'],
  ['marshal JSON failed: %w', 'JSON 编码失败：%w'],
  ['transfer detail unavailable', '传输详情不可用'],
  ['protocol error', '通信协议错误'],
  ['USB MSC active; stop USB mass storage before formatting eMMC', 'USB 大容量存储正在使用，请先停止后再格式化 eMMC'],
  ['format failed', '格式化失败'],
  ['factory reset rejected: USB MSC active', 'USB 大容量存储正在使用，无法恢复出厂设置'],
  ['factory reset failed: eMMC format failed', '恢复出厂设置失败：eMMC 格式化失败'],
  ['status unavailable', '状态不可用'],
  ['local upgrade baud is RS232/USB only', '本地升级波特率仅适用于 RS232/USB'],
  ['unsupported local upgrade baud', '不支持此本地升级波特率'],
  ['gnss upgrade baud failed', '设置 GNSS 升级波特率失败'],
  ['rs232 upgrade baud failed', '设置 RS232 升级波特率失败'],
  ['no active ota transfer', '当前没有进行中的升级传输'],
  ['missing enabled', '缺少启用状态参数'],
  ['watchdog test requires double confirm', '看门狗测试需要双重确认'],
  ['watchdog test unavailable', '看门狗测试不可用'],
  ['watchdog test unsupported', '不支持看门狗测试'],
  ['radio reset unavailable', '电台复位不可用'],
  ['missing installed hardware selector', '缺少已安装硬件型号参数'],
  ['invalid radio vendor', '电台型号无效'],
  ['invalid gnss chip', 'GNSS 芯片型号无效'],
  ['installed hardware unsupported by board', '板卡不支持已选择的硬件型号'],
  ['persist installed hardware failed', '保存硬件型号失败'],
  ['invalid sn (1-16 chars)', '设备 SN 无效，应为 1 至 16 个字符'],
  ['device sn is immutable once set', '设备 SN 设置后不能修改'],
  ['persist device sn failed', '保存设备 SN 失败'],
  ['invalid device model (1-31 chars)', '设备型号无效，应为 1 至 31 个字符'],
  ['persist device model failed', '保存设备型号失败'],
  ['invalid threshold', '阈值无效'],
  ['set boot fail threshold failed', '设置启动失败阈值失败'],
  ['persist boot fail threshold failed', '保存启动失败阈值失败'],
  ['missing confirmed', '缺少确认状态参数'],
  ['set image confirmed failed', '设置固件镜像确认状态失败'],
  ['recovery request failed', '请求恢复失败'],
  ['persist recovery request failed', '保存恢复请求失败'],
  ['clear recovery failed', '清除恢复请求失败'],
  ['persist recovery clear failed', '保存恢复请求清除状态失败'],
  ['missing boot fail reason', '缺少启动失败原因'],
  ['boot fail record failed', '记录启动失败原因失败'],
  ['persist boot fail failed', '保存启动失败记录失败'],
  ['unsupported control command', '不支持此控制命令'],
  ['missing or non-integer command', '控制命令缺失或不是整数'],
  ['persist factory reset failed', '保存恢复出厂设置失败'],
  ['format requires double confirm', '格式化需要双重确认'],
  ["invalid 'stream' field", '文件流类型参数无效'],
  ['stream must be nmea, rtcm, obs or ephem', '文件流类型必须为 NMEA、RTCM、观测或星历'],
  ['invalid 4g param', '4G 配置参数无效'],
  ['4g module unavailable', '4G 模块不可用'],
  ['invalid work mode', '工作模式无效'],
  ['invalid serial param', '串口配置参数无效'],
  ['radio module apply verify failed', '电台配置写入后校验失败'],
  ['invalid radio param', '电台配置参数无效'],
  ["requires boolean field 'enable'", '启用参数必须为布尔值'],
  ['invalid tcp param', 'TCP 配置参数无效'],
  ['invalid ntrip param', 'NTRIP 配置参数无效'],
  ['invalid mqtt param', 'MQTT 配置参数无效'],
  ['invalid mqtt2 param', 'MQTT2 配置参数无效'],
  ['invalid storage mount param', '存储挂载参数无效'],
  ['invalid storage param', '存储配置参数无效'],
  ['invalid gnss param', 'GNSS 配置参数无效'],
  ['missing url', '缺少下载地址'],
  ['upgrade busy or invalid', '设备正在升级或升级参数无效'],
  ['invalid url', '下载地址无效'],
  ['unsupported update target', '不支持此升级目标'],
  ['transfer already active', '已有正在进行的传输'],
  ['cloud not connected or request failed', '云平台未连接或请求失败'],
  ['invalid transfer chunk', '传输分块无效'],
  ['missing mode', '缺少模式参数'],
  ['unsupported update_mode', '不支持此升级模式'],
  ['invalid firmware chunk encoding', '固件分块编码无效'],
  ['missing total_len', '缺少总长度参数'],
  ['invalid transfer begin', '开始传输的参数无效'],
  ['invalid diff source param', '差分数据源参数无效'],
  ['invalid output profile param', '输出配置参数无效'],
  ['provide console_level (0-5) and/or file_level (0-5)', '请提供控制台或文件日志等级（0 至 5）'],
  ['config commit failed', '配置提交失败'],
  ['config save failed', '配置保存失败'],
  ['provide module and level', '请提供日志模块和等级'],
  ['module log override failed', '设置模块日志等级失败'],
  ['provide module or all=true', '请指定日志模块或选择全部模块'],
  ['module log override not found', '模块日志等级覆盖项不存在'],
  ['provide preset', '请提供日志预设'],
  ['unknown preset', '未知日志预设'],
  ['invalid log scope', '日志范围无效'],
  ['log clear incomplete', '日志清理未完成'],
  ['confirm=true required', '操作需要明确确认'],
  ['requires {"confirm":true} to prevent accidental data loss', '为防止数据误删，需要明确确认此操作'],
  ['stream clear failed', '清除数据流失败'],
  ['clear all streams failed', '清除全部数据流失败'],
  ['list failed', '读取文件列表失败'],
  ["missing 'file' field", '缺少文件名参数'],
  ["invalid 'file' field", '文件名参数无效'],
  ['file open failed', '打开文件失败'],
  ['seek failed', '文件定位失败'],
  ['read failed', '读取失败'],
  ['invalid result file read parameters', '解算结果文件读取参数无效'],
  ['result file read failed or artifact reader busy', '解算结果文件读取失败，或设备正忙于其他文件读取，请稍后重试。'],
  ['delete failed', '删除失败'],
  ['no valid config fields found', '未找到有效配置字段'],
  ['invalid host', '服务地址无效'],
  ['invalid port', '端口号无效'],
  ['missing caster host', '缺少差分服务地址'],
  ['ec800k fota start failed', 'EC800K 固件升级启动失败'],
  ['unsupported command', '不支持此命令'],
  ['json too long', 'JSON 内容过长'],
  ['json buffer alloc failed', '分配 JSON 缓冲区失败'],
  ['unsupported header version', '不支持此协议头版本'],
  ['missing cmd', '缺少命令参数'],
  ['Network Error', '网络连接失败，请检查网络后重试。'],
  ['timeout of %dms exceeded', '请求超时（%d 毫秒），请稍后重试。'],
  ['Request aborted', '请求已中止'],
  ['canceled', '请求已取消'],
  ['Failed to fetch', '网络请求失败，请检查网络后重试。'],
  ['connection refused', '连接被拒绝'],
  ['connection reset by peer', '对端重置了连接'],
  ['broken pipe', '连接已断开'],
  ['i/o timeout', '网络读写超时'],
  ['context deadline exceeded', '操作超过时限'],
  ['context canceled', '操作已取消'],
  ['EOF', '数据流已结束'],
  ['unexpected EOF', '数据流提前结束'],
  ['unauthorized', '未登录或登录状态已失效'],
  ['forbidden', '没有执行此操作的权限'],
  ['token expired', '登录状态已过期，请重新登录。'],
  ['invalid token', '登录凭据无效，请重新登录。'],
  ['token invalid', '登录凭据无效，请重新登录。'],
  ['system error,please contact the admin', '系统错误，请联系管理员。'],
  ['function not support', '不支持此功能'],
  ['params incorrect', '请求参数不正确'],
  ['url path is invalid', '请求地址无效'],
  ['ota bridge busy', '升级模块忙，请等待当前操作结束。'],
  ['invalid upgrade url', '升级下载地址无效'],
  ['cloud not connected or ota request failed', '云平台未连接或升级请求失败'],
  ['image too large for slot2', '固件镜像超过第二升级槽容量'],
  ['auto-aborted by new transfer begin', '新的升级传输已中止上一次传输'],
  ['start direct gnss firmware upgrade failed', '启动 GNSS 固件升级失败'],
  ['enter peripheral boot mode failed', '进入外设引导模式失败'],
  ['write peripheral firmware failed', '写入外设固件失败'],
  ['verify peripheral firmware failed', '外设固件校验失败'],
  ['exit peripheral boot mode failed', '退出外设引导模式失败'],
  ['confirm peripheral firmware failed', '外设固件确认失败'],
  ['read peripheral upgrade result failed', '读取外设升级结果失败'],
  ['no active transfer', '当前没有进行中的传输'],
  ['transfer overflow', '传输数据超出范围'],
  ['transfer idle timeout (%d min)', '传输等待数据超时（%d 分钟）'],
  ['chunk exceeds total_len', '分块超出传输总长度'],
  ['clear OTA marker failed', '清除升级标记失败'],
  ['flash erase failed', '闪存擦除失败'],
  ['flash write failed', '闪存写入失败'],
  ['flash read-back failed', '闪存读回失败'],
  ['flash CRC mismatch', '闪存 CRC 校验不一致'],
  ['mark ready for test failed', '设置固件试运行标记失败'],
  ['empty ota frame', '升级通信帧为空'],
  ['frame length mismatch', '通信帧长度不一致'],
  ['detail unavailable', '详细信息不可用'],
  ['frame transfer mismatch', '通信帧与当前传输不匹配'],
  ['partial duplicate overlap', '重复数据部分重叠'],
  ['offset mismatch', '偏移量不一致'],
  ['cloud link lost during transfer', '传输期间云平台连接中断'],
  ['transfer aborted', '传输已中止'],
  ['peripheral transfer aborted', '外设传输已中止'],
  ['boot fail', '设备启动失败'],
  ['ota request sent, waiting for firmware push', '升级请求已发送，正在等待固件推送'],
  ['precheck passed', '升级预检查通过'],
  ['waiting for first chunk', '正在等待第一个固件分块'],
  ['direct gnss firmware upgrade', 'GNSS 固件直接升级'],
  ['enter peripheral boot mode', '进入外设引导模式'],
  ['write peripheral firmware', '写入外设固件'],
  ['clear OTA marker', '清除升级标记'],
  ['erase slot2', '擦除第二升级槽'],
  ['transfer in progress', '正在传输固件'],
  ['verify image', '校验固件镜像'],
  ['verify peripheral firmware', '校验外设固件'],
  ['verify flash read-back', '校验闪存读回内容'],
  ['apply image', '应用固件镜像'],
  ['switch slot', '切换固件槽'],
  ['exit peripheral boot mode', '退出外设引导模式'],
  ['confirm image', '确认固件镜像'],
  ['confirm peripheral firmware', '确认外设固件'],
  ['peripheral upgrade done', '外设升级已完成'],
  ['transfer complete', '固件传输已完成'],
  ['gnss direct firmware write', 'GNSS 固件直接写入'],
  ['record not found', '记录不存在'],
  ['permission denied', '权限不足'],
  ['no such file or directory', '文件或目录不存在'],
  ['disk full', '存储空间已满'],
  ['no space left on device', '设备存储空间不足'],
  ['illegal base64 data at input byte %d', 'base64 数据在第 %d 个字节处无效'],
  ['superseded by OTA batch %s', '已被升级批次 %s 替代'],
  ['batch size %d exceeds maximum %d', '批量数量 %d 超过上限 %d'],
  ['invalid device online analytics request', '设备在线分析请求无效'],
  ['not implemented', '此功能尚未实现'],
  ['device id is empty', '设备编号为空'],
  ['device not found: %s', '设备不存在：%s'],
  ['active session not found: %s', '活动调试会话不存在：%s'],
  ['active session not found', '活动调试会话不存在'],
  ['device not found', '设备不存在'],
  ['template not found: %s', '模板不存在：%s'],
  ['raw command is empty', '原始命令为空'],
  ['unsupported command type: %s', '不支持命令类型 %s'],
  ['GNSS command cmd is required', 'GNSS 命令不能为空'],
  ['wait response timeout', '等待设备响应超时'],
  ['invalid property response', '属性响应无效'],
  ['invalid service response', '服务响应无效'],
  ['driver id(%s) time out', '驱动 %s 响应超时'],
  ['driver id(%s) not start', '驱动 %s 未启动'],
  ['please sync product data', '请先同步产品数据'],
  ['devices not found', '未找到设备'],
  ['please unbind the device with the driver first', '请先解除设备与驱动的绑定'],
  ['the device platform is inconsistent with the drive platform', '设备平台与驱动平台不一致'],
  ['unsupported instance type %s', '不支持实例类型 %s'],
  ['docker auth invalid', 'Docker 认证无效'],
  ['docker images not found', '未找到 Docker 镜像'],
  ['network connection error', '网络连接失败'],
  ['connection timeout', '连接超时'],
  ['driver library download error', '驱动库下载失败'],
  ['imageRepo is %s not exist', '镜像仓库 %s 不存在'],
  ['parse docker params err:%v', '解析 Docker 参数失败：%v'],
  ['device library upgrade in progress', '设备驱动库正在升级'],
  ['internal library not allow delete', '内置驱动库不允许删除'],
  ['must delete service', '请先删除关联服务'],
  ['missing endpoint', '缺少服务地址'],
  ['missing sms phone_numbers/template_id', '缺少短信接收号码或模板编号'],
  ['missing kafka brokers', '缺少 Kafka 服务地址'],
  ['missing kafka topic', '缺少 Kafka 主题'],
  ['missing mqtt endpoint', '缺少 MQTT 服务地址'],
  ['missing mqtt topic', '缺少 MQTT 主题'],
  ['missing smtp host', '缺少邮件服务器地址'],
  ['missing email receivers', '缺少邮件接收人'],
  ['integration type %s dispatch is not implemented', '集成类型 %s 尚未实现发送功能'],
  ['http status code: %d', 'HTTP 响应错误码：%d'],
  ['unsupported sasl mechanism: %s', '不支持 SASL 认证机制 %s'],
  ['tls cert/key must be provided together', 'TLS 证书和私钥必须同时提供'],
  ['failed to parse ca file', '解析 CA 证书文件失败'],
  ['missing rabbitmq host', '缺少 RabbitMQ 服务地址'],
  ['missing rabbitmq routing key', '缺少 RabbitMQ 路由键'],
  ['mqtt broker is empty', 'MQTT 服务地址为空'],
  ['mqtt connect timeout', 'MQTT 连接超时'],
  ['mqtt publish timeout', 'MQTT 发布超时'],
  ['integration dispatch completed with %d failures', '集成发送完成，其中 %d 项失败'],
  ['endpoint is empty', '服务地址为空'],
  ['automatic registration is disabled', '自动注册未启用'],
  ['product is required', '必须指定产品'],
  ['device model code is required when a model specification is selected', '选择型号规格后必须提供设备型号编码'],
  ['device model code is required to enable automatic registration', '启用自动注册必须提供设备型号编码'],
  ['unsupported device model: %s', '不支持设备型号 %s'],
  ['M30 model specification requires TCP protocol', 'M30 型号规格必须使用 TCP 协议'],
  ['product must be released before enabling automatic registration', '启用自动注册前必须先发布产品'],
  ['unsupported automatic registration mode: %s', '不支持自动注册模式 %s'],
  ['product model specification cannot be changed directly; create a new product for a different model specification', '不能直接修改产品型号规格，请为其他型号规格创建新产品'],
  ['released product model specification cannot be changed directly', '已发布产品的型号规格不能直接修改'],
  ['auto registration route conflict: route=%s product=%s', '自动注册路由冲突：路由 %s，产品 %s'],
  ['invite status is %s', '邀请状态为 %s，无法执行当前操作'],
  ['invite code has expired', '邀请码已过期'],
  ['invite email does not match current user', '邀请邮箱与当前用户不匹配'],
  ['system admin account can not be deleted', '系统管理员账号不能删除'],
  ['system admin account can not be disabled', '系统管理员账号不能停用'],
  ['failed to generate unique admin username', '生成唯一管理员用户名失败'],
  ['invalid user role payload', '用户角色参数无效'],
  ['req params error', '请求参数错误'],
  ['property definition is required', '必须提供属性定义'],
  ['database is unavailable', '数据库不可用'],
  ['unsupported metadata database type %q', '不支持元数据数据库类型 %q'],
  ['unsupported data database type %q', '不支持数据数据库类型 %q'],
  ['at least one field to update is required', '请至少提供一个要更新的字段'],
  ['unsupported target_type: %s', '不支持目标类型 %s'],
  ['rule_id is required', '必须提供规则编号'],
  ['forward quota exceeded', '数据转发配额已超限'],
  ['token is invalid', '登录凭据无效，请重新登录。'],
  ['Request token is invalid.', '请求凭据无效，请重新登录。'],
  ['gateway token is invalid', '网关凭据无效'],
  ['invalid websocket device library upgrade payload', 'WebSocket 设备驱动升级参数无效'],
  ['invalid websocket device service run status payload', 'WebSocket 设备服务运行状态参数无效'],
  ['param error', '参数错误'],
  ['device payload is empty', '设备参数为空'],
  ['CreateDeviceAndConnect is not implemented', '创建设备并连接的功能尚未实现'],
  ['DeleteDevice is not implemented', '删除设备功能尚未实现'],
  ['product not found', '产品不存在'],
  ['alert rule id(%s) not found', '告警规则 %s 不存在'],
  ['categoryTemplate id(%s) not found', '分类模板 %s 不存在'],
  ['database failed to init %w', '数据库初始化失败：%w'],
  ['mqtt auth resource id(%s) not found', 'MQTT 认证资源 %s 不存在'],
  ['device %s(%s) not found', '设备 %s（%s）不存在'],
  ['query mqtt auth failed (resourceId:%s), %s', '查询 MQTT 认证失败（资源 %s）：%s'],
  ['docker config id(%s)not found', 'Docker 配置 %s 不存在'],
  ['language sdk (%s) not found', '语言 SDK %s 不存在'],
  ['product id(%s) not found', '产品 %s 不存在'],
  ['query product fail (Id:%s), %s', '查询产品 %s 失败：%s'],
  ['thing model template category key(%s) not found', '物模型模板分类 %s 不存在'],
  ['ability type should be property or event', '功能类型必须为属性或事件'],
  ['legacy GNSS state synchronizer is unavailable', '旧版 GNSS 状态同步服务不可用'],
  ['device provisioner database is unavailable', '设备注册数据库不可用'],
  ['automatic device registration is disabled', '设备自动注册未启用'],
  ['identity-aware device provisioner is unavailable', '设备身份注册服务不可用'],
  ['device %s was concurrently registered to product %s, expected %s', '设备 %s 已被同时注册到产品 %s，预期产品为 %s'],
  ['registered device %s is bound to product %s, expected %s', '已注册设备 %s 绑定产品 %s，预期产品为 %s'],
  ['existing device %s has no product binding', '已有设备 %s 未绑定产品'],
  ['device model %s does not match existing product model %s', '设备型号 %s 与现有产品型号 %s 不匹配'],
  ['unsupported profile %s for existing product %s', '现有产品不支持配置 %s，产品编号 %s'],
  ['registration model code is empty', '注册型号编码为空'],
  ['no enabled model_match_private registration product for model %s', '型号 %s 没有已启用的私有自动注册产品'],
  ['ambiguous model registration route for %s: %d products enabled', '型号 %s 的注册路由不唯一，已启用 %d 个产品'],
  ['connection device sn is empty', '当前连接的设备 SN 为空'],
  ['registration identity payload is empty', '注册身份信息为空'],
  ['registration identity device_sn is required', '注册身份信息必须包含设备 SN'],
  ['registration identity sn %s does not match connection sn %s', '注册身份 SN %s 与连接 SN %s 不匹配'],
  ['registration identity device_model is required', '注册身份信息必须包含设备型号'],
  ['registration identity profile_name is required', '注册身份信息必须包含配置名称'],
  ['unsupported profile %s for model %s', '配置 %s 不适用于型号 %s'],
  ['device sn is empty', '设备 SN 为空'],
  ['automatic device registration is disabled for unknown device %s', '未知设备 %s 的自动注册未启用'],
  ['device %s requires verified GET_DEVICE_INFO identity before registration', '设备 %s 必须先通过设备信息身份校验才能注册'],
  ['legacy GNSS auto provision is disabled for unknown device %s', '未知设备 %s 的旧版 GNSS 自动注册未启用'],
  ['multiple released local TCP GNSS products found, auto provision is ambiguous', '存在多个已发布的本地 TCP GNSS 产品，无法确定自动注册目标'],
  ['multiple unreleased local TCP GNSS products found, auto provision is ambiguous', '存在多个未发布的本地 TCP GNSS 产品，无法确定自动注册目标'],
  ['legacy GNSS auto provision is disabled', '旧版 GNSS 自动注册未启用'],
  ['%w after %d attempts: %w', '%w（尝试 %d 次）：%w'],
  ['%w after %d attempts', '%w（尝试 %d 次）'],
  ['%w: task=%s status=%s', '%w：任务 %s，状态 %s'],
]
